import config from "../config";
import request, { requestOptions } from "../utils/request";
const baseUrl = `${config.API_ROOT}/app/subscription`;

const Settings = {
  async newPlan(payload) {
    const { priceId, origin, target, successUrl, cancelUrl } = payload || {};
    const options = await requestOptions(
      "POST",
      { priceId, origin, target, successUrl, cancelUrl },
      true
    );
    const url = `${baseUrl}/new-plan`;
    return request(url, options);
  },
  async changePlan({ subscriptionId, newPriceId }) {
    const options = await requestOptions(
      "POST",
      { subscriptionId, newPriceId },
      true
    );
    const url = `${baseUrl}/change-plan`;
    return request(url, options);
  },
  async createDashboardSession() {
    const options = await requestOptions("POST", {}, true);
    const url = `${baseUrl}/create-dashboard-session`;
    return request(url, options);
  },
};

export default Settings;
